<div class="common-dialog">
  <h2 mat-dialog-title *ngIf="!isEdit">新規登録</h2>
  <h2 mat-dialog-title *ngIf="isEdit">編集</h2>

  <mat-dialog-content class="mat-typography">
    <mat-form-field *ngIf="titleControl" class="item">
      <mat-label>タイトル</mat-label>
      <input matInput type="text" maxlength="20" [formControl]="titleControl">
      <mat-hint align="end">{{ titleControl.value?.length || 0 }}/20</mat-hint>
      <mat-error *ngIf="titleControl.hasError('required')">
        タイトルを入力してください。
      </mat-error>
    </mat-form-field>

    <mat-form-field *ngIf="textControl" class="item">
      <mat-label>本文</mat-label>
      <textarea matInput maxlength="400" [formControl]="textControl"></textarea>
      <mat-hint align="end">{{ textControl.value?.length || 0 }}/400</mat-hint>
      <mat-error *ngIf="textControl.hasError('required')">
        本文を入力してください。
      </mat-error>
    </mat-form-field>

    <div class="item" fxLayout="column" fxLayoutGap="16px" fxLayoutAlign="start">
      <label>画像</label><span>　※幅650px以上、5MBまで</span>
      <img class="image-preview" [src]="imageUrl">
      <input #imageFile hidden="true" type="file" (change)="onImageChanged()"
             onclick="this.value=null"
             accept=".png,.jpg"/>
      <div fxLayout="row" fxLayoutGap="16px" fxLayoutAlign="start">
        <button mat-flat-button color="primary" (click)="imageFile.click()">選択
        </button>
        <button mat-flat-button color="warn" (click)="onDeleteImageClicked()">削除
        </button>
      </div>
    </div>

  </mat-dialog-content>

  <mat-dialog-actions class="operation-container">
    <button mat-button [mat-dialog-close]="null">閉じる</button>
    <button mat-raised-button color="primary" (click)="onSave()">
      <span *ngIf="!isEdit">追加する</span>
      <span *ngIf="isEdit">更新する</span>
    </button>
  </mat-dialog-actions>

</div>
